import { withInstall } from '../../utils/vue-utils'
import _Descriptions from './src/descriptions'

export const Descriptions = withInstall(_Descriptions)
export type DescriptionsInstance = InstanceType<typeof _Descriptions>
export default Descriptions
